import React from 'react';
import PropTypes from "prop-types";
import sharepointIcon from "./icons/sharepointonline.png";
import OneDriveAuthenticator from "./OneDriveAuthenticator";
import {connectIntegration, disconnectIntegration} from "../../redux/actions/integrationsConnectionActions";

export default class SharepointSwitch extends React.Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    isLoading: false,
  };

  onClick = () => {
    const { connectionId } = this.props;

    if (connectionId) {
      this.props.dispatch(disconnectIntegration(connectionId));
    }
    else {
      this.setState({isLoading: true});

      // Sharepoint uses Graph API, just like OneDrive.
      // TOOD rename this to something like MicrosoftGraphAuthenticator
      OneDriveAuthenticator('full')
        .login({
          scope: 'files groups sites offline',
          state: {
            connection_type: 'full',
            redirect_host: window.location.host,
          }
        })
        .then(
          ({authResponse}) => {
            this.props.dispatch(connectIntegration('files', 'sharepoint', authResponse));
            this.setState({isLoading: false});
          },
          (res) => {
            const {code, message} = res.error;
            this.setState({isLoading: false});
            notify.error(`Error connecting to Sharepoint: [${code}] ${message || ''}`);
          }
        );
    }
  }

  render() {
    const {connectionId, agreedToPricing} = this.props;

    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2">
        <img className="kloudless-connection-icon"
             src={sharepointIcon}
             alt="Sharepoint Logo"
        />

        <div className={iconCls} onClick={this.onClick}>
          {this.state.isLoading
          && <i className={"fa fa-circle-o-notch fa-spin"}
                style={{marginTop: '10px', marginLeft: '11px', fontSize: '11px'}}/>
          }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Integrations/connections/SharepointSwitch.jsx